var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import queryString from 'query-string';
import { setAccessToken } from './redux/slices/auth';
import { store } from './redux/store';
import { getAuthorisationHeader } from './utils/getAuthorisationHeader';
var refreshToken = localStorage.getItem('refreshToken');
var accessToken = localStorage.getItem('accessToken');
var refreshAccessToken = function () { return __awaiter(void 0, void 0, Promise, function () {
    var res, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, clientOAuth.post('/jcb/service/oauth2/refresh_token', queryString.stringify({
                        grant_type: 'refresh_token',
                        refresh_token: refreshToken,
                    }), {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            Authorization: getAuthorisationHeader(process.env.OAUTH_CLIENT_ID, process.env.OAUTH_CLIENT_SECRET),
                        },
                    })];
            case 1:
                res = _a.sent();
                store.dispatch(setAccessToken(res.data.access_token));
                localStorage.setItem('accessToken', res.data.access_token);
                localStorage.setItem('refreshToken', res.data.refresh_token);
                return [2 /*return*/, res.data.access_token];
            case 2:
                err_1 = _a.sent();
                if (err_1.response.status === 400 || err_1.response.status === 401) {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    window.location.replace('/login');
                }
                if (window.location.pathname !== '/login') {
                    window.location.replace('/login');
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
var refreshAndRetryQueue = [];
var isRefreshing = false;
var client = axios.create({
    baseURL: process.env.API_URL,
    headers: {
        Authorization: "Bearer ".concat(accessToken),
    },
    params: {
        q: window.location.hostname === 'localhost.cognitran-cloud.com'
            ? 'skipskipskipskipskip'
            : '',
    },
});
client.interceptors.response.use(function (response) {
    return response;
}, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var originalRequest, newAccessToken;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                originalRequest = error.config;
                if (!(error.response && error.response.status === 401)) return [3 /*break*/, 5];
                if (!!isRefreshing) return [3 /*break*/, 4];
                isRefreshing = true;
                _a.label = 1;
            case 1:
                _a.trys.push([1, , 3, 4]);
                return [4 /*yield*/, refreshAccessToken()];
            case 2:
                newAccessToken = _a.sent();
                if (error.config) {
                    error.config.headers.Authorization = "Bearer ".concat(newAccessToken);
                }
                refreshAndRetryQueue.forEach(function (_a) {
                    var config = _a.config, resolve = _a.resolve, reject = _a.reject;
                    client
                        .request(config)
                        .then(function (response) { return resolve(response); })
                        .catch(function (err) { return reject(err); });
                });
                refreshAndRetryQueue.length = 0;
                return [2 /*return*/, client(originalRequest)];
            case 3:
                isRefreshing = false;
                return [7 /*endfinally*/];
            case 4: return [2 /*return*/, new Promise(function (resolve, reject) {
                    refreshAndRetryQueue.push({ config: originalRequest, resolve: resolve, reject: reject });
                })];
            case 5: return [2 /*return*/, Promise.reject(error)];
        }
    });
}); });
var clientOAuth = axios.create({
    baseURL: process.env.IWA_URL,
    headers: {
        Authorization: "Bearer ".concat(accessToken),
    },
});
clientOAuth.interceptors.response.use(function (response) {
    return response;
}, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var originalRequest, newAccessToken;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                originalRequest = error.config;
                if (!(error.response && error.response.status === 401)) return [3 /*break*/, 5];
                if (!!isRefreshing) return [3 /*break*/, 4];
                isRefreshing = true;
                _a.label = 1;
            case 1:
                _a.trys.push([1, , 3, 4]);
                return [4 /*yield*/, refreshAccessToken()];
            case 2:
                newAccessToken = _a.sent();
                if (error.config) {
                    error.config.headers.Authorization = "Bearer ".concat(newAccessToken);
                }
                refreshAndRetryQueue.forEach(function (_a) {
                    var config = _a.config, resolve = _a.resolve, reject = _a.reject;
                    client
                        .request(config)
                        .then(function (response) { return resolve(response); })
                        .catch(function (err) { return reject(err); });
                });
                refreshAndRetryQueue.length = 0;
                return [2 /*return*/, client(originalRequest)];
            case 3:
                isRefreshing = false;
                return [7 /*endfinally*/];
            case 4: return [2 /*return*/, new Promise(function (resolve, reject) {
                    refreshAndRetryQueue.push({ config: originalRequest, resolve: resolve, reject: reject });
                })];
            case 5: return [2 /*return*/, Promise.reject(error)];
        }
    });
}); });
export { client, clientOAuth };
